import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Register the service worker
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      });
      console.log('SW registered: ', registration);
      
      // Force update if there's a waiting worker
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      
      // Listen for messages from the service worker
      // Only reload on cache updates if we haven't reloaded recently
      const RELOAD_THRESHOLD = 24 * 60 * 60 * 1000; // 24 hours
      
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'CACHE_UPDATED') {
          const lastReload = localStorage.getItem('last_cache_reload');
          const now = Date.now();
          
          if (!lastReload || (now - parseInt(lastReload)) > RELOAD_THRESHOLD) {
            console.log('New version detected and reload threshold met, reloading page...');
            localStorage.setItem('last_cache_reload', now.toString());
            window.location.reload();
          } else {
            console.log('New version detected but within reload threshold, skipping reload');
          }
        }
      });
      
      // Handle controller change less aggressively
      let reloadTimeout;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Clear any existing reload timeout
        if (reloadTimeout) {
          clearTimeout(reloadTimeout);
        }
        
        // Set a new timeout to reload only if no other reload happens within 5 minutes
        reloadTimeout = setTimeout(() => {
          const lastReload = localStorage.getItem('last_cache_reload');
          const now = Date.now();
          
          if (!lastReload || (now - parseInt(lastReload)) > RELOAD_THRESHOLD) {
            console.log('Service Worker controller changed and reload threshold met, reloading...');
            localStorage.setItem('last_cache_reload', now.toString());
            window.location.reload();
          }
        }, 300000); // 5 minutes
      });
    } catch (error) {
      console.error('SW registration failed: ', error);
    }
  });
}
